module.exports = __webpack_public_path__ + "img/auth-考试宝典线下体验中心.9065decd.jpg";